import { render, staticRenderFns } from "./psform.vue?vue&type=template&id=3fb5f68a&scoped=true&"
import script from "./psform.vue?vue&type=script&lang=js&"
export * from "./psform.vue?vue&type=script&lang=js&"
import style0 from "./psform.vue?vue&type=style&index=0&id=3fb5f68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5f68a",
  null
  
)

export default component.exports